// extracted by mini-css-extract-plugin
export default {"lessonCard":"LessonCard_lessonCard__ffstj","outer":"LessonCard_outer__fwap6","inner":"LessonCard_inner__HlaGE","buyButton":"LessonCard_buyButton__7bEgB"};